import { useTheme } from "@mui/material"
import { useContextState } from "../../../../../../../../hooks/theme"
import { assignColor } from "../../../../../../../../utils/methods/assignColor"

const useStyles = () => {
    const { colors } = useContextState()
    const { breakpoints } = useTheme()

    return {
        container: {
            padding: '20px 0px 0px 30px',
            display: 'flex',
            alignItems: 'center',
            gap:'8px',
            [breakpoints.between(1201,1436)]: { //1385
                display: 'block',
              },
        },
        progressContainer: ({ progress }: { progress: number }) => {
            return{
                color: assignColor(progress),
                '& .MuiTypography-root':{
                    fontWeight: 'bold'
                },
                '& .MuiLinearProgress-bar': {
                    backgroundColor: assignColor(progress), // Color del progreso
                },
                '& .MuiLinearProgress-root': {
                    backgroundColor: colors.color39, // Color del área sin progreso
                    height: '10px',
                    borderRadius: '5px',
                    width: '200px',
                },
            }
        },
        title: {
            display: 'flex',
            alignItems: 'center',
            gap:'8px',
            width: '50%',
            [breakpoints.between(1201,1436)]: {
                marginBottom: '0px',
                width: '100%',
              },
        },
        titleAnswer: {
            marginLeft: '10px',
        },
        progressAndAlert: {
            width: '50%',
            [breakpoints.between(1201,1436)]: {
                width: '100%',
                marginTop: '10px'
              },
        },
        flexProgressAndAlert: {
            display: 'flex',
            alignItems: 'center', 
        },
        alerts: {
            marginBottom: '-20px',
            fontSize: '14px',
            marginLeft: '10px',
            fontWeight: '500',
        },
        image: {
            width: '30px',
            height: '30px',
            borderRadius: '100%',
        },
        alertText: {
            color:'c_red.main',
            fontStyle: 'italic'
        },
        smallDate: {
            width: '50%',
            [breakpoints.between(1201,1436)]: {
                width: '100%',
              },
            marginLeft: 'auto', 
            /* marginTop: '-20px' */
        },
        bigDate: {
            width:'100%',
            padding: '20px 0px 0px 30px', 
            display:'flex',
            flexWrap: 'wrap',
        },
        marginRigt: {
            marginRight: '4px'
        },
        openAnswerContainer: {
            display:'flex',
            width: '100%',
            [breakpoints.between(1201,1436)]: { //1385
                display: 'block',
              },
        },
        freeAnswerText: {
            width: '50%',
            [breakpoints.between(1201,1436)]: {
                marginBottom: '0px',
                width: '100%',
              },            
        },
        displayBlock:{
            display: 'block',
            paddingBottom: '10px', 
        },
        hiden: {
            display: 'none'
        },
        freeAlerts:{
            fontSize: '14px',
            marginLeft: '10px',
            fontWeight: '500',
        },
        linearProgress: {
            backgroundColor: 'transparent !important',
            borderRadius: '5px',
            '& .MuiLinearProgress-bar': {
                borderRadius: '5px',
            }
        },
        containerCatalog: {
            padding: '20px 0px 0px 30px',
        },
        dropList: {
            //display: 'flex',
            '& .MuiTypography-root': {
                wordBreak: "break-word",
                overflowWrap: "break-word",
                whiteSpace: "normal",
            },
        },
        line: { 
            borderTop: `1px solid ${colors.color25}`, 
            mt:3 
        }
    }
}

export { useStyles }